import {
    Box,
    Button,
    Grid,
    Theme,
    Typography
} from "@mui/material";
import BreadCrum from "../../../lib/BreadCrum";
import { useHistory } from "react-router";
import useQuery from "../../../utils/useQuery";

import { RootStateType } from "../../../redux-store/reducers";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { navigationData as NavigationData } from "../types";

import { NO_DATA_ERROR_MESSAGE, USER_ROLES } from "../../../utils/constant";
import { formatCurrency, isModuleAllowed } from "../../../utils/utilityFunctions";
import { InfoCardLoading } from "../directEquity/LoadingComponents";
import { DirectEquityData, InfoCardProps } from "../directEquity/types";
import { useEffect, useState } from "react";
import { ChartIcon, CurrencyIcon, MoneyGrow, PercentageIcons, TotalInvestors } from "../../../assets/SvgIcons";
import { getInsuranceCompanyOverview, getInsuranceCompanyTurnover, getInsurancePolicyDetails, getInsurancePremiumSchedule } from "../../../redux-store/actions/product";
import { InsuranceCompanyOverviewRes, InsuranceCompanyTurnoverRes, InsurancePolicyDetailsRes, InsurancePremiumScheduleRes } from "../../../redux-store/types/products";
import CustomTable from "../common/customTable";
import { CompanyTurnoverDataTableUN, CompanyTurnoverDataTableUY, CompanyTurnoverTableHeaderDataUN, CompanyTurnoverTableHeaderDataUY, PolicyDetailsDataTableUN, PolicyDetailsDataTableUY, PolicyDetailsNonInvestorData, PolicyDetailsTableHeaderDataUN, PolicyDetailsTableHeaderDataUY, PremiumScheduleDataTable, PremiumScheduleTableHeaderData } from "./TablesLayout";

function InfoCard({
    Icon,
    title,
    value = 0,
    percentage = 0,
    valueTextColor = "text.primary",
    isLoading,
    key
}: InfoCardProps) {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const formatedPercentage = !Number.isNaN(Number(percentage ?? 0)) ?
        Math.round((percentage ?? 0) * 100) / 100 : '0'

    return (
        <Box
            sx={(theme: Theme) => ({
                backgroundColor: theme.palette.common.white,
                borderRadius: "15px",
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                border: `3px solid ${theme.palette.stroke.main}`,
                padding: "25px 18px",
                display: "flex",
                height: "100%",
                alignItems: "center",
            })}
        >
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Icon />
            </Box>
            <Box
                sx={{
                    flex: 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    rowGap: "8px",
                    width: '80%',
                }}
            >
                {isLoading && <InfoCardLoading />}
                {!isLoading && (
                    <>
                        <Typography
                            variant="subtitle_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "14px",
                                color: theme.palette.text.primary,
                            })}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="h3"
                            sx={{
                                lineHeight: "27.5px",
                                color: valueTextColor
                            }}
                        >
                            {title === "Market value (Ulip)" && (
                                (value ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(value ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: value ?? 0, locale, currencyCode })}`
                            )}
                            {title === "Policy Count" && (
                                value ?? 0
                                // (value ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(value ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: value ?? 0, locale, currencyCode })}`
                            )}
                            {title === "Premium Paid" && (
                                (value ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(value ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: value ?? 0, locale, currencyCode })}`
                            )}
                            {/* {title === "ABSOLUTE RETURN %" && (
                                !Number.isNaN(Number(value ?? 0)) ?
                                    `${Math.round((value ?? 0) * 100) / 100} %` : '0 %'
                            )} */}
                            {title === "Ulip Policy Count" && (
                                value ?? 0
                            )}
                        </Typography>
                    </>
                )}
            </Box>

        </Box>
    )
}

export default function Insurance(): JSX.Element {
    const dispatch = useDispatch()

    const history = useHistory();

    const { pathname: pathName, state } = history.location
    const navState = state as NavigationData
    const clientCode = navState?.clientCode ?? ""

    const query = useQuery()

    const initialRouter = pathName.split('/').filter((item: string) => item !== '')

    const { selectedPortfolio } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { label: selectedPortfolioLabel = "", value: selectedPortfolioValue = "" } = selectedPortfolio

    const { role = '', permissions = [] } = useSelector((store: RootStateType) => store.auth);

    const { iwappRmId = "", investorClientId = "", clientInterfaceCode = '' } = useSelector((store: RootStateType) => store.id);
    const { clientInterfaceCode: investorRmId = "" } = useSelector((store: RootStateType) => store.id);

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
        },
        ...(!initialRouter.includes('product') ? [{
            name: `${initialRouter[1]} ${selectedPortfolioLabel ? `(${selectedPortfolioLabel})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: { clientCode }
        }] : []),
        {
            name: 'Insurance',
            path: !initialRouter.includes('product') ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}` : `/${initialRouter[0]}/${initialRouter[1]}}`,
            state: { clientCode }
        }
    ] : []);

    const investorRouterPath = [
        {
            name: `Dashboard ${selectedPortfolio?.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
        },
        {
            name: 'Insurance',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: { clientCode }
        }
    ];

    const initialCompanyOverviewData = [
        {
            Icon: (props: React.SVGProps<SVGSVGElement>) => <MoneyGrow {...props} viewBox="0 0 57 50" />,
            title: "Market value (Ulip)",
            value: 0,
            key: 'marketValue'
        },
        {
            Icon: (props: React.SVGProps<SVGSVGElement>) => <CurrencyIcon {...props} />,
            title: "Policy Count",
            value: 0,
            key: 'policyCount'
        },
        {
            Icon: (props: React.SVGProps<SVGSVGElement>) => <ChartIcon {...props} viewBox="0 0 57 50" />,
            title: "Premium Paid",
            value: 0,
            percentage: 0,
            // valueTextColor: 'success.500',
            key: 'premiumPaid'
        },
        {
            Icon: (props: React.SVGProps<SVGSVGElement>) => <TotalInvestors {...props} viewBox="0 0 57 50" />,
            title: "Ulip Policy Count",
            value: 0,
            key: 'ulipCount'
        }
        // {
        //     Icon: initialRouter.includes('product') ? (props: React.SVGProps<SVGSVGElement>) => <TotalInvestors {...props} viewBox="0 0 57 50" /> : (props: React.SVGProps<SVGSVGElement>) => <PercentageIcons {...props} viewBox="0 0 57 50" />,
        //     title: initialRouter.includes('product') ? "Ulip Policy Count" : "ABSOLUTE RETURN %",
        //     value: 0,
        //     key: 'ulipCount'
        // }
    ]
    const [selectedTab, setSelectedTab] = useState<string>('Overview');
    const isInvestorView = !pathName.includes('product');
    const tabsList = isInvestorView ? ['Overview', 'Premium Schedule', 'Policy Details'] : ['Overview', 'Policy Details']

    const [loadingObj, setLoadingObj] = useState<{ [key: string]: boolean }>({
        fetchCompanyTurnoverUY: false,
        fetchCompanyTurnoverUN: false,
        fetchCompanyOverview: false,
        fetchPremiumSchedule: false,
        fetchPolicyDetailsUY: false,
        fetchPolicyDetailsUN: false
    })

    const [errorObj, setErrorObj] = useState<{ [key: string]: boolean }>({
        fetchCompanyTurnoverUY: true,
        fetchCompanyTurnoverUN: true,
        fetchCompanyOverview: true,
        fetchPremiumSchedule: true,
        fetchPolicyDetailsUY: true,
        fetchPolicyDetailsUN: true
    })

    const [responseObj, setResponseObj] = useState<{ [key: string]: any }>({
        fetchCompanyTurnoverUY: null,
        fetchCompanyTurnoverUN: null,
        fetchCompanyOverview: { isSuccess: true, data: initialCompanyOverviewData },
        fetchPremiumSchedule: null,
        fetchPolicyDetailsUY: null,
        fetchPolicyDetailsUN: null
    })

    const [premiumScheduleKeys, setPremiumScheduleKeys] = useState<string[]>([])

    const fetchCompanyOverview = async () => {
        try {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchCompanyOverview: true
            }));
            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${selectedPortfolioValue ?? investorRmId}`,
                insCompany: ''
            }
            const res = (await dispatch(getInsuranceCompanyOverview(payload)) as unknown) as InsuranceCompanyOverviewRes;
            if (res.isSuccess) {
                setResponseObj(prevState => ({
                    ...prevState,
                    fetchCompanyOverview: {
                        isSuccess: true,
                        data: prevState.fetchCompanyOverview.data.map((obj: DirectEquityData) => {
                            if (obj.title === "Market value (Ulip)") {
                                return {
                                    ...obj,
                                    value: res?.data?.[0]?.marketValue ?? 0
                                }
                            }
                            if (obj.title === "Policy Count") {
                                return {
                                    ...obj,
                                    value: res?.data?.[0]?.policyCount ?? 0
                                }
                            }
                            if (obj.title === "Premium Paid") {
                                return {
                                    ...obj,
                                    value: res?.data?.[0]?.premiumPaid ?? 0,
                                }
                            }
                            if (obj.title === "Ulip Policy Count") {
                                return {
                                    ...obj,
                                    value: res?.data?.[0]?.ulipCount ?? 0,
                                }
                            }

                            // if (obj.title === "Total Investors") {
                            //     return {
                            //         ...obj,
                            //         value: res?.data?.[0]?.totalInvestors ?? 0
                            //     }
                            // }
                            return obj
                        })
                    }
                }))
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchCompanyOverview: false
                }))
            } else {
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchCompanyOverview: true
                }))
            }

        } catch {
            setErrorObj(prevState => ({
                ...prevState,
                fetchCompanyOverview: true
            }))
        } finally {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchCompanyOverview: false
            }))
        }
    }

    const fetchCompanyTurnoverUY = async () => {
        try {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchCompanyTurnoverUY: true
            }));
            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${selectedPortfolioValue ?? investorRmId}`,
                insCompany: '',
                isUlip: 'Y'
            }

            const res = (await dispatch(getInsuranceCompanyTurnover(payload)) as unknown) as InsuranceCompanyTurnoverRes
            if (res.isSuccess) {
                setResponseObj(prevState => ({
                    ...prevState,
                    fetchCompanyTurnoverUY: res
                }))
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchCompanyTurnoverUY: false
                }))
            } else {
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchCompanyTurnoverUY: true
                }))
            }

        } catch {
            setErrorObj(prevState => ({
                ...prevState,
                fetchCompanyTurnoverUY: true
            }))
        } finally {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchCompanyTurnoverUY: false
            }))
        }
    }

    const fetchCompanyTurnoverUN = async () => {
        try {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchCompanyTurnoverUN: true
            }));
            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${selectedPortfolioValue ?? investorRmId}`,
                insCompany: '',
                isUlip: 'N'
            }

            const res = (await dispatch(getInsuranceCompanyTurnover(payload)) as unknown) as InsuranceCompanyTurnoverRes
            if (res.isSuccess) {
                setResponseObj(prevState => ({
                    ...prevState,
                    fetchCompanyTurnoverUN: res
                }))
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchCompanyTurnoverUN: false
                }))
            } else {
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchCompanyTurnoverUN: true
                }))
            }

        } catch {
            setErrorObj(prevState => ({
                ...prevState,
                fetchCompanyTurnoverUN: true
            }))
        } finally {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchCompanyTurnoverUN: false
            }))
        }
    }

    const fetchPremiumSchedule = async () => {
        try {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchPremiumSchedule: true
            }));
            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${selectedPortfolioValue ?? investorRmId}`,
                insCompany: '',
                isUlip: 'Y'
            }
            const res = (await dispatch(getInsurancePremiumSchedule(payload)) as unknown) as InsurancePremiumScheduleRes;
            if (res.isSuccess) {
                setResponseObj(prevState => ({
                    ...prevState,
                    fetchPremiumSchedule: res
                }))
                setPremiumScheduleKeys(Object.keys(res.data));
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchPremiumSchedule: false
                }))
            } else {
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchPremiumSchedule: true
                }))
            }
        } catch {
            setErrorObj(prevState => ({
                ...prevState,
                fetchPremiumSchedule: true
            }))
        } finally {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchPremiumSchedule: false
            }))
        }
    }

    const fetchPolicyDetailsUY = async () => {
        try {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchPolicyDetailsUY: true
            }));
            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${selectedPortfolioValue ?? investorRmId}`,
                insCompany: '',
                isUlip: 'Y'
            }
            const res = (await dispatch(getInsurancePolicyDetails(payload)) as unknown) as InsurancePolicyDetailsRes;
            if (res.isSuccess) {
                setResponseObj(prevState => ({
                    ...prevState,
                    fetchPolicyDetailsUY: res
                }))
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchPolicyDetailsUY: false
                }))
            } else {
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchPolicyDetailsUY: true
                }))
            }
        } catch {
            setErrorObj(prevState => ({
                ...prevState,
                fetchPolicyDetailsUY: true
            }))
        } finally {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchPolicyDetailsUY: false
            }))
        }
    }
    const fetchPolicyDetailsUN = async () => {
        try {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchPolicyDetailsUN: true
            }));
            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${selectedPortfolioValue ?? investorRmId}`,
                insCompany: '',
                isUlip: 'N'
            }
            const res = (await dispatch(getInsurancePolicyDetails(payload)) as unknown) as InsurancePolicyDetailsRes;
            if (res.isSuccess) {
                setResponseObj(prevState => ({
                    ...prevState,
                    fetchPolicyDetailsUN: res
                }))
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchPolicyDetailsUN: false
                }))
            } else {
                setErrorObj(prevState => ({
                    ...prevState,
                    fetchPolicyDetailsUN: true
                }))
            }
        } catch {
            setErrorObj(prevState => ({
                ...prevState,
                fetchPolicyDetailsUN: true
            }))
        } finally {
            setLoadingObj(prevState => ({
                ...prevState,
                fetchPolicyDetailsUN: false
            }))
        }
    }

    useEffect(() => {
        fetchCompanyTurnoverUY()
        fetchCompanyTurnoverUN()
        fetchCompanyOverview()
    }, [])

    const handleTabChange = (currentTab: string) => {
        selectedTab !== currentTab && setSelectedTab(currentTab);
        if (currentTab === "Overview") {
            fetchCompanyTurnoverUY()
            fetchCompanyTurnoverUN()
        }
        if (currentTab === "Premium Schedule") {
            isInvestorView && fetchPremiumSchedule();
        }
        if (currentTab === "Policy Details") {
            fetchPolicyDetailsUY();
            fetchPolicyDetailsUN()
        }
    }

    return (
        <Box sx={{ marginTop: "15px" }}>
            <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            <Grid
                container
                sx={{
                    marginTop: { xs: "10px", md: "25px" },
                    display: "flex",
                }}
                spacing={2}
            >
                {responseObj.fetchCompanyOverview.data.map((obj: DirectEquityData) => (
                    <Grid
                        item
                        key={obj.title}
                        xs={12}
                        md={6}
                        lg={3}
                    >
                        <InfoCard
                            Icon={obj.Icon}
                            title={obj.title}
                            value={obj.value}
                            // key={obj.key}
                            percentage={obj?.percentage}
                            valueTextColor={obj?.valueTextColor}
                            isLoading={loadingObj.fetchCompanyOverview}
                        />
                    </Grid>
                ))}
            </Grid>
            <Grid container sx={{ mt: { xs: '20px', md: '35px' }, overflowX: 'auto', width: '100%', flexWrap: 'nowrap', borderBottom: '1px solid #E0E0E0', pb: '20px' }}>
                {tabsList.map((item) => {
                    return (
                        <Button
                            variant={selectedTab === item ? "contained" : "text"}
                            key={item}
                            onClick={() => handleTabChange(item)}
                            sx={(theme: Theme) => ({
                                padding: '5px 15px',
                                background: selectedTab === item ? theme.palette.primary[500] : 'transparent',
                                borderRadius: '7px',
                                outline: 'none',
                                border: 'none',
                                cursor: 'pointer'
                            })}
                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: selectedTab === item ? theme.palette.textDark.primary : theme.palette.text.secondary,
                                    wordBreak: 'keep-all'
                                })}
                            >
                                {item}
                            </Typography>
                        </Button>
                    )
                })}
            </Grid>
            <Grid
                container
                sx={{
                    marginTop: {
                        xs: '10px',
                        md: '15px'
                    },
                    display: "flex",
                    flexDirection: 'column'
                }}
                spacing={3}
            >
                {
                    selectedTab === 'Overview' && (
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: { xs: "10px", md: "25px" },
                                    padding: {
                                        xs: "20px",
                                        md: "25px"
                                    },
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                    border: `3px solid ${theme.palette.stroke.main}`,
                                })}

                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingBottom: { xs: "10px", md: "15px" },
                                    }}
                                >
                                    <Typography
                                        variant="h2"
                                        sx={(theme: Theme) => ({
                                            lineHeight: '25px',
                                            letterSpacing: "0.01px",
                                            color: theme.palette.text.primary,
                                        })}
                                    >
                                        Company wise turnover (Ulip)
                                    </Typography>
                                </Box>
                                {(loadingObj.fetchCompanyTurnoverUY) && (<Box >
                                    <CustomTable
                                        isLoading={true}
                                        tableHeaderData={CompanyTurnoverTableHeaderDataUY}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>)}
                                {(!loadingObj.fetchCompanyTurnoverUY && errorObj.fetchCompanyTurnoverUY) &&
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 500,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.01px",
                                                color: theme.palette.text.primary,
                                                textAlign: "center",
                                                width: "100%"
                                            })}
                                        >
                                            {NO_DATA_ERROR_MESSAGE}
                                        </Typography>
                                    </Box>
                                }
                                {(!loadingObj.fetchCompanyTurnoverUY && !errorObj.fetchCompanyTurnoverUY) && <Box>
                                    <CustomTable
                                        isLoading={false}
                                        tableBody={
                                            <CompanyTurnoverDataTableUY data={responseObj.fetchCompanyTurnoverUY.data} />
                                        }
                                        tableData={responseObj.fetchCompanyTurnoverUY.data}
                                        tableHeaderData={CompanyTurnoverTableHeaderDataUY}
                                        isPaginationVisible={false}
                                        tableDataCount={responseObj.fetchCompanyTurnoverUY.data.length}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        tableBodyCustomStyles={{
                                            '& tr:last-child td': {
                                                border: 0
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>}
                            </Box>
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: { xs: "10px", md: "25px" },
                                    padding: {
                                        xs: "20px",
                                        md: "25px"
                                    },
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                    border: `3px solid ${theme.palette.stroke.main}`,
                                })}

                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingBottom: { xs: "10px", md: "15px" },
                                    }}
                                >
                                    <Typography
                                        variant="h2"
                                        sx={(theme: Theme) => ({
                                            lineHeight: '25px',
                                            letterSpacing: "0.01px",
                                            color: theme.palette.text.primary,
                                        })}
                                    >
                                        Company wise turnover (Non-Ulip)
                                    </Typography>
                                </Box>
                                {(loadingObj.fetchCompanyTurnoverUN) && (<Box >
                                    <CustomTable
                                        isLoading={true}
                                        tableHeaderData={CompanyTurnoverTableHeaderDataUN}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>)}
                                {(!loadingObj.fetchCompanyTurnoverUN && errorObj.fetchCompanyTurnoverUN) &&
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 500,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.01px",
                                                color: theme.palette.text.primary,
                                                textAlign: "center",
                                                width: "100%"
                                            })}
                                        >
                                            {NO_DATA_ERROR_MESSAGE}
                                        </Typography>
                                    </Box>
                                }
                                {(!loadingObj.fetchCompanyTurnoverUN && !errorObj.fetchCompanyTurnoverUN) && <Box>
                                    <CustomTable
                                        isLoading={false}
                                        tableBody={
                                            <CompanyTurnoverDataTableUN data={responseObj.fetchCompanyTurnoverUN.data} />
                                        }
                                        tableData={responseObj.fetchCompanyTurnoverUN.data}
                                        tableHeaderData={CompanyTurnoverTableHeaderDataUN}
                                        isPaginationVisible={false}
                                        tableDataCount={responseObj.fetchCompanyTurnoverUN.data.length}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        tableBodyCustomStyles={{
                                            '& tr:last-child td': {
                                                border: 0
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>}
                            </Box>
                        </Grid>
                    )
                }
                {
                    selectedTab === 'Premium Schedule' && (
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: { xs: "10px", md: "25px" },
                                    padding: {
                                        xs: "20px",
                                        md: "25px"
                                    },
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                    border: `3px solid ${theme.palette.stroke.main}`,
                                })}

                            >
                                {(loadingObj.fetchPremiumSchedule) && (<Box >
                                    <CustomTable
                                        isLoading={true}
                                        tableHeaderData={PremiumScheduleTableHeaderData}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>)}
                                {(!loadingObj.fetchPremiumSchedule && errorObj.fetchPremiumSchedule) &&
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 500,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.01px",
                                                color: theme.palette.text.primary,
                                                textAlign: "center",
                                                width: "100%"
                                            })}
                                        >
                                            {NO_DATA_ERROR_MESSAGE}
                                        </Typography>
                                    </Box>
                                }
                                {(!loadingObj.fetchPremiumSchedule && !errorObj.fetchPremiumSchedule) &&
                                    <Box>
                                        {
                                            premiumScheduleKeys.length > 0 && (
                                                premiumScheduleKeys.map((key: string, index: number) => (
                                                    <Box key={index}>
                                                        <Typography
                                                            variant="body_600"
                                                            sx={(theme: Theme) => ({
                                                                fontWeight: 500,
                                                                lineHeight: "22.5px",
                                                                letterSpacing: "0.01px",
                                                                color: theme.palette.text.primary,
                                                                textAlign: "left",
                                                                width: "100%",
                                                                marginBottom: "25px"
                                                            })}
                                                        >
                                                            Policy : <strong> {key}</strong>
                                                        </Typography>
                                                        <CustomTable
                                                            isLoading={false}
                                                            tableBody={
                                                                <PremiumScheduleDataTable data={responseObj.fetchPremiumSchedule.data?.[key]} />
                                                            }
                                                            tableData={responseObj.fetchPremiumSchedule.data?.[key]}
                                                            tableHeaderData={PremiumScheduleTableHeaderData}
                                                            isPaginationVisible={false}
                                                            tableDataCount={responseObj.fetchPremiumSchedule.data?.[key].length}
                                                            tableBodyLoaderRowCustomStyles={{
                                                                '& td:first-of-type': {
                                                                    paddingLeft: "0px"
                                                                },
                                                            }}
                                                            tableHeadRowCustomStyles={{
                                                                '& th:first-of-type': {
                                                                    paddingLeft: "0px"
                                                                }
                                                            }}
                                                            tableBodyCustomStyles={{
                                                                '& tr:last-child td': {
                                                                    border: 0
                                                                }
                                                            }}
                                                            loadingRowsNum={5}
                                                        />
                                                    </Box>
                                                ))
                                            )
                                        }
                                    </Box>
                                }
                            </Box>
                        </Grid>
                    )
                }
                {
                    selectedTab === 'Policy Details' && (

                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: { xs: "10px", md: "25px" },
                                    padding: {
                                        xs: "20px",
                                        md: "25px"
                                    },
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                    border: `3px solid ${theme.palette.stroke.main}`,
                                })}

                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingBottom: { xs: "10px", md: "15px" },
                                    }}
                                >
                                    <Typography
                                        variant="h2"
                                        sx={(theme: Theme) => ({
                                            lineHeight: '25px',
                                            letterSpacing: "0.01px",
                                            color: theme.palette.text.primary,
                                        })}
                                    >
                                        Policy details (Ulip)
                                    </Typography>
                                </Box>
                                {(loadingObj.fetchPolicyDetailsUY) && (<Box >
                                    <CustomTable
                                        isLoading={true}
                                        tableHeaderData={isInvestorView ? PolicyDetailsTableHeaderDataUY : [...PolicyDetailsNonInvestorData, ...PolicyDetailsTableHeaderDataUY]} tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>)}
                                {(!loadingObj.fetchPolicyDetailsUY && errorObj.fetchPolicyDetailsUY) &&
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 500,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.01px",
                                                color: theme.palette.text.primary,
                                                textAlign: "center",
                                                width: "100%"
                                            })}
                                        >
                                            {NO_DATA_ERROR_MESSAGE}
                                        </Typography>
                                    </Box>
                                }
                                {(!loadingObj.fetchPolicyDetailsUY && !errorObj.fetchPolicyDetailsUY) && <Box>
                                    <CustomTable
                                        isLoading={false}
                                        tableBody={
                                            <PolicyDetailsDataTableUY data={responseObj.fetchPolicyDetailsUY.data} />
                                        }
                                        tableData={responseObj.fetchPolicyDetailsUY.data}
                                        tableHeaderData={isInvestorView ? PolicyDetailsTableHeaderDataUY : [...PolicyDetailsNonInvestorData, ...PolicyDetailsTableHeaderDataUY]}
                                        isPaginationVisible={false}
                                        tableDataCount={responseObj.fetchPolicyDetailsUY.data.length}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        tableBodyCustomStyles={{
                                            '& tr:last-child td': {
                                                border: 0
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>}
                            </Box>
                            <Box
                                sx={(theme: Theme) => ({
                                    borderRadius: { xs: "10px", md: "25px" },
                                    padding: {
                                        xs: "20px",
                                        md: "25px"
                                    },
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                    border: `3px solid ${theme.palette.stroke.main}`,
                                })}

                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingBottom: { xs: "10px", md: "15px" },
                                    }}
                                >
                                    <Typography
                                        variant="h2"
                                        sx={(theme: Theme) => ({
                                            lineHeight: '25px',
                                            letterSpacing: "0.01px",
                                            color: theme.palette.text.primary,
                                        })}
                                    >
                                        Policy details (Non-Ulip)
                                    </Typography>
                                </Box>
                                {(loadingObj.fetchPolicyDetailsUN) && (<Box >
                                    <CustomTable
                                        isLoading={true}
                                        tableHeaderData={isInvestorView ? PolicyDetailsTableHeaderDataUN : [...PolicyDetailsNonInvestorData, ...PolicyDetailsTableHeaderDataUN]}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>)}
                                {(!loadingObj.fetchPolicyDetailsUN && errorObj.fetchPolicyDetailsUN) &&
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontWeight: 500,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.01px",
                                                color: theme.palette.text.primary,
                                                textAlign: "center",
                                                width: "100%"
                                            })}
                                        >
                                            {NO_DATA_ERROR_MESSAGE}
                                        </Typography>
                                    </Box>
                                }
                                {(!loadingObj.fetchPolicyDetailsUN && !errorObj.fetchPolicyDetailsUN) && <Box>
                                    <CustomTable
                                        isLoading={false}
                                        tableBody={
                                            <PolicyDetailsDataTableUN data={responseObj.fetchPolicyDetailsUN.data} />
                                        }
                                        tableData={responseObj.fetchPolicyDetailsUN.data}
                                        tableHeaderData={isInvestorView ? PolicyDetailsTableHeaderDataUN : [...PolicyDetailsNonInvestorData, ...PolicyDetailsTableHeaderDataUN]}
                                        isPaginationVisible={false}
                                        tableDataCount={responseObj.fetchPolicyDetailsUN.data.length}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}
                                        tableBodyCustomStyles={{
                                            '& tr:last-child td': {
                                                border: 0
                                            }
                                        }}
                                        loadingRowsNum={5}
                                    />
                                </Box>}
                            </Box>
                        </Grid>
                    )
                }
            </Grid>
        </Box >
    )
}